import config from '../utils/config';
import { getHomeMapView } from '../queries/home';
// eslint-disable-next-line import/no-cycle
import { getHomeMapViewQueryOptions } from '../selectors/homeMapSelectors';
// eslint-disable-next-line import/no-cycle
import { trackTappedSearchThisArea } from './tracking/homeMap';
import {
  HOME_TOGGLE_MAP_VIEW,
  FETCH_HOME_MAP_VIEW,
  SET_HOME_MAP_SELECTED_RESTAURANT_ID,
} from './types';

const API_TIMEOUT = 10000;

export const toggleMapView = () => ({ type: HOME_TOGGLE_MAP_VIEW });

export const requestHomeMapView = ({ location } = {}) => (dispatch, getState) => {
  const state = getState();
  const queryOptions = getHomeMapViewQueryOptions(state);

  if (location) {
    queryOptions.location = location;
  }

  const options = {
    method: 'POST',
    timeout: API_TIMEOUT,
    body: getHomeMapView(queryOptions),
  };

  const actionBlob = {
    type: FETCH_HOME_MAP_VIEW,
    host: config.homeApiHost,
    endpoint: '/consumer/graphql/',
    options,
  };

  /**
   * The location override is used when the
   * user clicks on "Search this area".
   */
  if (location) {
    actionBlob.onSuccess = () => {
      dispatch(
        trackTappedSearchThisArea({
          lat: location.lat,
          lng: location.lon,
        }),
      );
    };
  }

  return dispatch(actionBlob);
};

export const setHomeMapSelectedRestaurantId = (restaurantId) => ({
  type: SET_HOME_MAP_SELECTED_RESTAURANT_ID,
  restaurantId,
});
